import axios from 'axios';
import { path } from '../constants';
import { jwtDecode } from "jwt-decode";



const BASE_URL = process.env.REACT_APP_BASE_URL;
let refreshingToken = false;

const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

axiosInstance.interceptors.request.use(
  async(config:any) => {
    let accessToken = localStorage.getItem("access_token");
    const decodedToken: any = accessToken ? jwtDecode(accessToken) : "";
    const currentTime = Date.now() / 1000;

    if (config?.url !== "login/token/refresh" && refreshingToken) {
      return;
    }
    if (
      decodedToken?.exp &&
      decodedToken.exp < currentTime &&
      config?.url !== "/login/token/refresh"
    ) {
      try {
        const refreshToken = localStorage.getItem("refresh_token");
        if (refreshToken) {
          const headers = {
            refresh_token: refreshToken,
          };
          refreshingToken = true;
          const res = await axios.get(
            `${BASE_URL}/login/token/refresh`,
            {headers}
          );
          localStorage.setItem("access_token", res.data.access_token);
          localStorage.setItem("refresh_token", res.data.refresh_token);
          accessToken = res.data.access_token;
        
        }
      } catch (err) {
       
        localStorage.clear();
        if (process.env.REACT_APP_FRONTEND_BASE_URL) {    
          if(sessionStorage.getItem('redirect_url')){      
          window.location.href = `${process.env.REACT_APP_FRONTEND_BASE_URL}?redirect_url=${sessionStorage.getItem('redirect_url')}`;

          }else{
          
            window.location.href = process.env.REACT_APP_FRONTEND_BASE_URL;
          }
        }
        console.log("Error refreshing access token:", err);
      } finally {
        refreshingToken = false;
      }
    }
    if (accessToken) {
      config.headers["Authorization"] = "Bearer " + accessToken;
    }
   
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (refreshingToken) {
      return;
    }
    const refreshToken = localStorage.getItem('refresh_token');
    console.error({error})
    if (error?.response?.data?.status === 404) {
      window.location.href = path.PAGE_NOT_FOUND;
    } else if (
      refreshToken &&
      error.response.data.statusCode === 401 &&
      !originalRequest._retry
    ) {
  

      originalRequest._retry = true;
      try {
        const headers = {
          refresh_token: refreshToken,
        };
        const res = await axios.get(`${BASE_URL}/login/token/refresh`, {
          headers,
        });

        localStorage.setItem("access_token", res.data.access_token);
        localStorage.setItem("refresh_token", res.data.refresh_token);
        originalRequest.headers.Authorization = `Bearer ${res.data.access_token}`;
        return axios(originalRequest);
      } catch (error) {

        localStorage.clear();
        console.log("Error refreshing access token:", error);
        if (process.env.REACT_APP_FRONTEND_BASE_URL) {
          if(sessionStorage.getItem('redirect_url')){
          window.location.href = `${process.env.REACT_APP_FRONTEND_BASE_URL}?redirect_url=${sessionStorage.getItem('redirect_url')}`;

          }else{
            
            window.location.href = process.env.REACT_APP_FRONTEND_BASE_URL;
          }
        }

      }
    }else if( error.response.data.statusCode === 400){
      return Promise.reject(error);
    }else{
      if (process.env.REACT_APP_FRONTEND_BASE_URL) {
     


        window.location.href = process.env.REACT_APP_FRONTEND_BASE_URL;
      }
    }
    if(error.response.data.message=='Invalid Access Token' || error.response.data.message=='Invalid token' || error.response.data.message=='Access Token is required' ){

      error.response.data.message='Something went wrong, Please login'
    }
  
    return Promise.reject(error);
  }
);

export default axiosInstance;
